export class LeaveUpdateModel {
    constructor(
        public BajaId?:number,
        public Fbaja?:string,
        public Falta?:string,
        public AvisoBaja?:string,
        public AvisoAlta?:string,
        public Tipo?:string,
        public Recaida?:string,
        public leaveRef?:string,
        public CodDiagnostico?:string,
        public TipoDiagnostico?:string,
        public GrupoDiagnostico?:number,
        public Diagnostico?:string,
        public Agudo?:string,
        public Cronico?:string,
        public Cirujia?:string,
        public Embarazada?:string,
        public Fpa?:string,
        public RiesgosPsicosociales?:string,
        public Justificada?:string,
        public Actitud?:string,
        public MedicoId?:number
    ){

    }
}